interface HeaderMessageProps {
  completed?: boolean;
  length?: number;
  initial?: string;
  multiple?: string;
  complete?: string;
}

const HeaderMessage = ({
  completed = false,
  length = 1,
  initial,
  multiple,
  complete,
}: HeaderMessageProps) => {
  const initialMessage = length > 1 ? multiple : initial;
  const message = completed ? complete : initialMessage;

  return message;
};

export default HeaderMessage;
